import {Col, ContentContainer, Row, FormHeader, TextLink} from '@snsw-gel/react';
import React, {useEffect} from 'react';
import { IconNotificationError } from '@snsw-gel/react';
import config from '../../config/config';
import styled from 'styled-components';
import {userInfo} from 'src/utils/sessionStorage';
import { EventData, generateEventData } from 'src/utils/ga-page-tracking';

const BottomWrapper = styled.p`
    margin-bottom: 4rem;
`;

const PreferredNameErrorPage = () => {

const userInfoObj = userInfo();
useEffect(() => {
    if (userInfoObj && userInfoObj.id) {
        // Simulating data for the event
        const eventData: EventData = {
            page_title: 'We need additional details to continue',
            transaction_info: {
                transaction_step: 'Preferred name error page',
            },
            user_info: {
                user_id: userInfoObj.id,
                user_login_status: 'fully authenticated',
            },
        };

        // Generating and pushing the event data to the dataLayer
        generateEventData(eventData);
    }
}, [userInfoObj]);

    return (
        <>
            <FormHeader title={
                <>
                    <IconNotificationError size={28} /> We need additional details to continue
                </>
            }/>
            <ContentContainer>
                <Row>
                    <Col span={8}>
                        <p>We require you to add your preferred name to your MyServiceNSW Account to continue.</p>
                        <p>Follow these steps to add your preferred name:</p>
                        <ol>
                            <li>Go to your {' '}
                                <TextLink
                                    href={config.links.myAccountLoginPage}
                                    id='MyServiceNSWAccountLink'
                                    target='_blank'
                                    rel='noreferrer noopener'
                                >
                                    {' '} MyServiceNSW Account
                                </TextLink>
                            </li>
                            <li>Select ‘Manage Account’</li>
                            <li>Choose ‘Personal Details’</li>
                            <li>Select ‘Update’ in ‘Your details’ and add your preferred name. You need to include a 'First name' and 'Family name'.</li>
                        </ol>
                        <BottomWrapper>After you've added your preferred name, you may need to wait 24 hours, and then go to {' '}
                            <TextLink
                                href={config.links.manageTollAccountPage}
                                id='MyServiceNSWAccountLink'
                                target='_blank'
                            >
                                Manage Toll Account
                            </TextLink>
                            {' '} to link your toll account.
                        </BottomWrapper>
                    </Col>
                </Row>
            </ContentContainer>
        </>
    );
};

export default PreferredNameErrorPage;
